import { EntityResource } from '@app/store/filters/models/filters.model';

export enum FilterProps {
  COMPANY = 'company',
  DIVISIONS = 'divisions',
  LOCATIONS = 'locations'
}
export interface FilterDialogState {
  powerOn: boolean;
  company: string;
  divisions: string[];
  //locations: string[];
  driver?: EntityResource;
  siteGroup?: boolean;
}

export const initialFilterDialogState: FilterDialogState = {
  powerOn: false,
  company: null,
  divisions: [],
  //locations: [],
  driver: null,
  siteGroup: false
};

export interface FilterChangeEvent {
  entity: FilterProps;
  value: string | string[];
  options?: { title: string; value: string }[];
}
